import { useQuery } from '@tanstack/react-query';
import { getJournalists } from '../contactsRequest';

export const useJournalists = () => {
  return useQuery({
    queryKey: ['journalists'],
    queryFn: getJournalists,
  });
};
